export const ENDPOINTS = {
  INITIAL_SYNC: '/initial_sync',
};
